<template>
    <b-container fluid>
        <b-row align-v="center">
            <b-col cols="12" md="5">
                <app-form-text-input
                    v-model="item.name"
                    placeholder="Item"
                    :required="true"
                    :has-error="$v.item.name.$error"
                    error-message="Debe especificar un nombre"
                    @input="$v.item.name.$touch()"
                />
            </b-col>
            <b-col cols="12" md="5">
                <app-form-text-input
                    v-model="item.description"
                    placeholder="Descripción"
                />
            </b-col>
            <b-col cols="12" md="2">
                <b-btn variant="primary" block @click="addItem"
                    ><i class="fa fa-plus"></i
                ></b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import roundsRepository from "@repositories/rounds.repository";
export default {
    props: {
        round: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        item: {
            name: "",
            description: ""
        }
    }),
    validations: {
        item: {
            name: { required }
        }
    },
    methods: {
        async addItem() {
            this.$v.$touch();
            if (this.$v.$invalid) return;

            const payload = {
                ...this.item,
                roundId: this.round.id,
                userId: this.user.id
            };

            const rr = { ...roundsRepository };

            try {
                const { data } = await rr.saveChecklistItem(payload);

                if (data.status) {
                    this.round.check_list.push(data.item);
                    Object.keys(this.item).map(key => (this.item[key] = ""));
                    this.$v.$reset();
                    this.$emit("save", data.item);
                } else {
                    toastr.error(data.msg);
                }
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al guardar el item [${err.message}]`
                );
            }
        }
    }
};
</script>
